import React from 'react';

export const Logo: React.FC<{ className?: string } & React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg width="126" viewBox="0 0 472 170" {...props}>
      <path
        fill="currentColor"
        d="M176.2 50.4c-18.1 0-32.7 14.6-32.7 32.7s14.6 32.7 32.7 32.7 32.7-14.6 32.7-32.7c0-18-14.6-32.7-32.7-32.7zm0 50.8c-10 0-18-8.1-18-18 0-10 8.2-18 18-18 10 0 18 8.1 18 18 .1 9.9-8 18-18 18z"
      />
      <path
        fill="currentColor"
        d="M101.2 89.6l22.4-9 13.6-5.5c-1-4-2.8-7.8-5.2-11-5.9-8.3-15.5-13.5-26.3-13.6h-.2c-17.9.2-32.7 14.8-32.7 32.6 0 17.9 14.6 32.5 32.5 32.5 10.9 0 21-5.4 27-14.4l-11.9-8.1c-3.3 5.2-9 8.3-15.1 8.3-10.1 0-18.2-8.3-18.2-18.2 0-10 8.3-18.2 18.2-18.2 4.7 0 9.3 1.8 12.5 4.8l-21.2 8.5 4.6 11.3z"
      />
      <path
        fill="currentColor"
        d="M33.7 50.4c-16.5 0-30.1 12.2-32.4 28.2v72.2h14.4v-40.3c5.2 3.4 11.4 5.3 18 5.3 18.1 0 32.7-14.6 32.7-32.7 0-18-14.6-32.7-32.7-32.7zm0 50.8c-9.8 0-17.8-7.9-18-17.5v-.5c0-10.1 8.1-18.1 18-18.1s18 8.1 18 18c0 10.1-8.1 18.1-18 18.1z"
      />
      <path
        fill="currentColor"
        d="M248 50.4c-18.1 0-32.7 14.6-32.7 32.7s14.6 32.7 32.7 32.7 32.7-14.6 32.7-32.7c0-18-14.7-32.7-32.7-32.7zm0 50.8c-10 0-18-8.1-18-18 0-10 8.1-18 18-18 10 0 18 8.1 18 18s-8 18-18 18z"
      />
      <path
        fill="currentColor"
        d="M319.8 50.4c-17.5 0-31.8 13.8-32.7 31.1v2.4l-.2 66.8h14.8v-40.3c5.2 3.5 11.4 5.4 18.1 5.4 18.1 0 32.7-14.6 32.7-32.7-.1-18-14.7-32.7-32.7-32.7zm-.1 50.8c-9.8 0-17.8-7.9-18-17.5v-.5c0-10.1 8.1-18.1 18-18.1 10 0 18 8.1 18 18 0 10.1-8.1 18.1-18 18.1z"
      />
      <path
        fill="currentColor"
        d="M430.3 78.6l4.5 11.1.1-.1v.1l18.1-7.3 3.8-1.5 12.8-5.1v-.1l.8-.3c-.9-4-2.7-7.7-5.1-10.9-5.8-8.1-15.3-13.3-25.9-13.4h-.2c-3.2 0-6.3.5-9.2 1.4h-.1l-.9.3c-6 2-11.2 5.6-15.1 10.4-4.3 5.2-6.9 11.8-7.1 19v1.3c0 9.9-8.4 17.4-18.2 17.4-9.7 0-17.5-7.7-17.8-17.3V19.4h-14.6v64c0 .8 0 1.5.1 2.3v.3c1.3 16.6 15.3 29.7 32.1 29.7 10.2 0 19.3-4.7 25.3-12.1 5.9 7.3 15 12 25 12 4.7 0 9.3-1 13.5-3 5.3-2.4 9.9-6.3 13.3-11.3l-11.7-8-.1.1h-.1c-3.3 5-8.8 8-14.8 8.1-9.9 0-17.9-8.2-17.9-18s8.1-17.9 17.9-18c4.6 0 9.1 1.8 12.2 4.8l-20.7 8.3z"
      />
    </svg>
  );
};
